<template>
    <service-card :services="getServices"></service-card>
</template>

<script>
import { mapGetters } from 'vuex';
import ServiceCard from '@components/ServiceCard.vue';
import { NAVIGATION, GET_SERVICES } from '@constants/navigation';

export default {
    name: 'home',
    computed: {
        ...mapGetters(NAVIGATION, [GET_SERVICES])
    },
    components: { ServiceCard }
};
</script>
